// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2RnHr","list":"PatternAutocomplete_list__2dX36"};